import axios from "axios";
import { handleSuccessOne } from "@store/action/GlobalAction";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;
const radio_id = localStorage.getItem("radio_id");

export const getMenus = (params) => (dispatch) => {
  axios.get(`${API}${VERSION}/menus`, { params }).then((response) => {
    dispatch({
      type: "GET_MENUS",
      data: response.data.data.Menus.data,
      totalPages: response.data.data.Menus.total,
      params,
    });
  });
};
export const createMenu = (data, func) => (dispatch) => {
  data.radio_id = radio_id;
  axios
    .post(`${API}${VERSION}/menu`, data)
    .then((res) => {
      dispatch({
        type: "ADD_MENU_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getMenus());
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_MENU_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_MENU_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};

export const EditMenu = (id, data, func) => (dispatch) => {
  axios
    .put(`${API}${VERSION}/menu/${id}`, data)
    .then((response) => {
      dispatch({
        type: "EDIT_MENU_SUCCESS",
        payload: response.data,
      });
      func();
      handleSuccessOne(response.data.message);
      dispatch(getMenus());
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_MENU_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_MENU_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};

export const EditStatusMenu = (id, status, params) => (dispatch) => {
  axios
    .put(`${API}${VERSION}/menu/update/status/${id}/?status=${status}`)
    .then((response) => {
      dispatch({
        type: "EDIT_STATUS_MENU_SUCCESS",
        payload: response.data,
      });
      {
        status === 0
          ? handleSuccessOne("Menu status switched to Drafted ")
          : handleSuccessOne("Menu status switched to Published");
      }
      dispatch(getMenus(params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_STATUS_MENU_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_STATUS_MENU_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
